"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Mail, TrendingUp, Users } from "lucide-react";
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const benefits = [{
    icon: Mail,
    title: "Expert Email Strategies",
    description: "Data-driven campaigns tailored to your restaurant's unique brand and audience."
  }, {
    icon: TrendingUp,
    title: "Measurable Growth",
    description: "Track ROI with detailed analytics that show real results and repeat visits."
  }, {
    icon: Users,
    title: "Seamless Integration",
    description: "Connect effortlessly with your existing reservation and POS systems."
  }];
  return <section className="py-16 px-6 bg-gradient-to-b from-primary-light/40 to-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-foreground mb-4">
            Why Choose Us
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Click Viral combines industry expertise with cutting-edge email marketing to drive sustainable growth for restaurants.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <Card key={i} data-index={i} className="group bg-background border border-border hover:border-primary/30 hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] cursor-default">
                <CardContent className="flex flex-col items-center text-center pt-8 pb-8 px-6">
                  <div className="mb-6 p-4 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                    <IconComponent className="w-10 h-10 text-primary group-hover:text-primary-hover transition-colors duration-[var(--duration-medium)]" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-display font-semibold text-foreground mb-3 group-hover:font-bold transition-all duration-[var(--duration-medium)]">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}